import type { SycurioErrorEventType } from '../types/SycurioTypes';

import {
  getSycurioPCIResponse,
  type SycurioPCIResponseType,
} from './getSycurioPCIResponse';
import { getSycurioPageHeight } from './getSycurioPageHeight';
import {
  isMessageTypeSubmit,
  hasCapturedPaymentMethodResponse,
} from './hasCapturedPaymentMethodResponse';
import { hasSycurioPageHeight } from './hasSycurioPageHeight';
import { hasValidPCIResponse } from './hasValidPCIResponse';
import { isMessageFromSycurio } from './isMessageFromSycurio';

export const generateSycurioMessageListenerCallback =
  ({
    sycurioHttpOrigin,
    onSubmitHandler,
    onErrorHandler,
    setSycurioPageHeight,
  }: {
    sycurioHttpOrigin: string;
    onSubmitHandler: (data: SycurioPCIResponseType) => void;
    onErrorHandler: (data: SycurioErrorEventType) => void;
    setSycurioPageHeight: (
      currentState: React.SetStateAction<string | undefined>,
    ) => void;
  }) =>
  <T>(event: MessageEvent<T>) => {
    if (
      sycurioHttpOrigin &&
      !isMessageFromSycurio({ event, sycurioHttpOrigin })
    ) {
      return;
    }
    if (typeof event.data === 'string') {
      if (hasSycurioPageHeight(event)) {
        const iframePageHeight = getSycurioPageHeight(
          event.data,
        );
        setSycurioPageHeight(iframePageHeight);
      }
      if (!isMessageTypeSubmit(event.data)) {
        return;
      }
      const sycurioPCIResponse = getSycurioPCIResponse(
        event.data,
      );
      if (
        hasCapturedPaymentMethodResponse(event.data) &&
        hasValidPCIResponse(event.data)
      ) {
        onSubmitHandler(sycurioPCIResponse);
        return;
      }
      const errorMessage =
        sycurioPCIResponse?.ppErrorCode &&
        sycurioPCIResponse?.ppErrorMessage
          ? sycurioPCIResponse.ppErrorMessage
          : 'Something went wrong.';
      onErrorHandler({
        sycurioErrorType: 'submitError',
        message: errorMessage,
      });
      console.error(
        'Something went wrong with submitting the form.',
      );
    }
  };
